import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dog-entry" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "data-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.dog.imageRef)
      ? (_openBlock(), _createBlock($setup["DocRefImage"], {
          key: 0,
          "img-ref": $props.dog.imageRef
        }, null, 8, ["img-ref"]))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: $setup.DoggoImage
        }, null, 8, _hoisted_2)),
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _cache[0] || (_cache[0] = _createElementVNode("td", null, "Name", -1)),
        _createElementVNode("td", null, _toDisplayString($props.dog.name), 1)
      ]),
      _createElementVNode("tr", null, [
        _cache[1] || (_cache[1] = _createElementVNode("td", null, "Weight", -1)),
        _createElementVNode("td", null, _toDisplayString($props.dog.weight || "unset") + " lbs (" + _toDisplayString($props.dog.size) + ")", 1)
      ]),
      _createElementVNode("tr", null, [
        _cache[2] || (_cache[2] = _createElementVNode("td", null, "Breed", -1)),
        _createElementVNode("td", null, _toDisplayString($props.dog.breed), 1)
      ]),
      _createElementVNode("tr", null, [
        _cache[3] || (_cache[3] = _createElementVNode("td", null, "Age", -1)),
        _createElementVNode("td", null, _toDisplayString($props.dog.age || "unset"), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode($setup["VaccineStatus"], {
        vax: $props.dog.vaccines
      }, null, 8, ["vax"])
    ])
  ]))
}